import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { EliteProgram } from '../components/EliteProgram';
import { Schedule } from '../components/Schedule';
import { VideoGallery } from '../components/VideoGallery';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    document.title = 'HoopIQ - Elite Basketball Training by Matt Pugh';
    // Handle hash anchor scrolling when navigating from other pages
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <Services />
      <EliteProgram />
      <Schedule />
      <VideoGallery />
    </>
  );
}
